import { orderingAndLimit } from "./variables"

const filter = "_type == 'editorial' && visibility == true"
const filterSection = `${filter} && section->slug.current == $section`
const fields = `{
    _id,
    title,
    slug,
    teaser,
    section->{name, slug, hideTimestamp},
    publishedAt,
  }`

const allFields = `{..., section->{name, slug, hideTimestamp}}`

export const { getFirstPage: getAllFirstPage, getNextPage: getAllNextPage } =
  queries(filter, orderingAndLimit, fields)

export const {
  getFirstPage: getSectionFirstPage,
  getNextPage: getSectionNextPage,
} = queries(filterSection, orderingAndLimit, fields)

export const getBySlugSection = () =>
  groq`*[_type == 'editorial' && section->slug.current == $section && slug.current == $slug][0]${allFields}`

export const getEditorialSectionBySlug = () =>
  groq`*[_type == 'editorialSection' && slug.current == $slug][0]`

export const getById = () =>
  groq`*[_type == 'editorial' && _id == $id][0]${allFields}`

export const searchByTerm = () => {
  const filter = `_type == 'editorial' &&
    visibility == true &&
    (
      title match $term ||
      title match $normalizedTerm ||
      section->name match $term ||
      section->name match $normalizedTerm
    )`

  const { getFirstPage, getNextPage } = queries(
    filter,
    orderingAndLimit,
    fields,
  )

  return {
    getFirstPage,
    getNextPage,
  }
}
